import { render, staticRenderFns } from "./addActivity.vue?vue&type=template&id=7d45d966&scoped=true"
import script from "./addActivity.vue?vue&type=script&lang=js"
export * from "./addActivity.vue?vue&type=script&lang=js"
import style0 from "./addActivity.vue?vue&type=style&index=0&id=7d45d966&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d45d966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d45d966')) {
      api.createRecord('7d45d966', component.options)
    } else {
      api.reload('7d45d966', component.options)
    }
    module.hot.accept("./addActivity.vue?vue&type=template&id=7d45d966&scoped=true", function () {
      api.rerender('7d45d966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/clientAnddistributionChild/addActivity.vue"
export default component.exports